import React from 'react';
import CommonPortfilo from './CommonPortfilo';

const Portfilo = () => {
    return (
        <div>
            <CommonPortfilo items={9} condition={true}/>
        </div>
    );
};

export default Portfilo;